<template>
  <div
    v-if="product_data && product_data.GoodsTimeEnd != null"
    class="w-full max-w-screen-xl py-2 mx-auto mb-5 text-center text-white bg-black rounded-xl"
  >
    <p class="mb-2 text-sm text-basic_gray">{{ event_title }}</p>
    <div class="flex items-end justify-center">
      <h4 class="mr-1 text-3xl font-medium text-primary">{{ day }}</h4>
      <p class="mr-5 text-sm text-basic_gray">天</p>
      <h4 class="mr-1 text-3xl font-medium text-primary">{{ hr }}</h4>
      <p class="mr-5 text-sm text-basic_gray">時</p>
      <h4 class="mr-1 text-3xl font-medium text-primary">{{ min }}</h4>
      <p class="mr-5 text-sm text-basic_gray">分</p>
      <h4 class="mr-1 text-3xl font-medium text-primary">{{ sec }}</h4>
      <p class="text-sm text-basic_gray">秒</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "EventTimer",
  props: {
    product_data: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      count_down_timer: null,
      event_title: "",
      //
      day: "00",
      hr: "00",
      min: "00",
      sec: "00",
    };
  },
  methods: {
    SetTimer() {
      if (this.product_data == null) return;
      if (
        this.product_data.GoodsTimeStart == null ||
        this.product_data.GoodsTimeEnd == null
      )
        return;

      if (new Date().getTime() < this.start_time) {
        this.SetEventCountDown(this.product_data.GoodsTimeStart);
        this.event_title = "距離商品開賣還有";
      } else {
        this.SetEventCountDown(this.product_data.GoodsTimeEnd);
        this.event_title = "販售時間剩餘";
      }
    },
    SetEventCountDown(current_time) {
      this.count_down_timer != null ? clearInterval(this.count_down_timer) : "";
      this.count_down_timer = setInterval(() => {
        // 設置倒數計時: 結束時間 - 當前時間
        // 當前時間
        if (!current_time) {
          clearInterval(this.count_down_timer);
          return false;
        }

        let time = new Date();
        let nowTime = time.getTime(); // 獲取當前毫秒數
        let end_time = new Date(current_time.replace(" ", "T")).getTime();
        if (end_time < nowTime) {
          clearInterval(this.count_down_timer);
          return false;
        }

        this.GetCountDownTimeString(end_time, nowTime);
      }, 1000);
    },
    GetCountDownTimeString(end_time, nowTime) {
      // 倒數計時: 差值
      let offsetTime = (end_time - nowTime) / 1000; // ** 以秒為單位
      let sec = parseInt(offsetTime % 60); // 秒
      let min = parseInt((offsetTime / 60) % 60); // 分 ex: 90秒
      let hr = parseInt((offsetTime / 60 / 60) % 24); // 時
      let day = parseInt(offsetTime / 60 / 60 / 24); // 天

      if (day > 0) {
        this.day = day;
      }
      this.hr = hr.toString().padStart(2, "0");
      this.min = min.toString().padStart(2, "0");
      this.sec = sec.toString().padStart(2, "0");
    },
  },
  computed: {
    start_time() {
      if (!this.product_data || !this.product_data.GoodsTimeStart) return 0;
      // 直接使用 Date 建構子解析 ISO 格式字串
      // 格式: "YYYY-MM-DD HH:mm:ss"
      return new Date(
        this.product_data.GoodsTimeStart.replace(" ", "T")
      ).getTime();
    },
    end_time() {
      if (!this.product_data || !this.product_data.GoodsTimeEnd) return 0;
      // 直接使用 Date 建構子解析 ISO 格式字串
      // 格式: "YYYY-MM-DD HH:mm:ss"
      return new Date(
        this.product_data.GoodsTimeEnd.replace(" ", "T")
      ).getTime();
    },
  },
  watch: {
    product_data() {
      this.SetTimer();
    },
  },
  created() {
    this.SetTimer();
  },
};
</script>
